import React from 'react';
import { Badge } from '@fluentui/react-components';

interface StatusBadgeProps {
  status: string;
  type?: 'opportunity' | 'project' | 'action' | 'risk';
}

const OPPORTUNITY_COLORS: Record<string, 'success' | 'warning' | 'danger' | 'informative' | 'subtle'> = {
  qualification: 'informative',
  proposal: 'warning',
  negotiation: 'warning',
  won: 'success',
  lost: 'danger',
  abandoned: 'subtle',
};

const RISK_COLORS: Record<string, 'success' | 'warning' | 'danger' | 'informative'> = {
  low: 'success',
  medium: 'warning',
  high: 'danger',
  critical: 'danger',
};

const STAGE_LABELS: Record<string, string> = {
  '1': 'Qualification',
  '2': 'Proposition',
  '3': 'Négociation',
  '4': 'Gagné',
  '5': 'Perdu',
  '6': 'Abandonné',
  qualification: 'Qualification',
  proposal: 'Proposition',
  negotiation: 'Négociation',
  won: 'Gagné',
  lost: 'Perdu',
  abandoned: 'Abandonné',
  active: 'Actif',
  closed: 'Clôturé',
  paused: 'En pause',
  low: 'Faible',
  medium: 'Moyen',
  high: 'Élevé',
  critical: 'Critique',
};

export default function StatusBadge({ status, type = 'opportunity' }: StatusBadgeProps) {
  let color: 'success' | 'warning' | 'danger' | 'informative' | 'subtle' = 'subtle';

  if (type === 'risk') {
    color = RISK_COLORS[status] || 'subtle';
  } else {
    color = OPPORTUNITY_COLORS[status] || 'informative';
  }

  const label = STAGE_LABELS[status] || status || '—';

  return (
    <Badge appearance="filled" color={color} size="small">
      {label}
    </Badge>
  );
}
